import React from "react";

function HiluxPortraitDefault() {
  return (
    <div className="bg-[#020202] flex flex-col items-center justify-center w-full h-full relative">
      <div className="flex flex-col items-center gap-[40px]">
        <img
          src="/logo.png"
          alt="올바른 운동"
          className="w-[786px] h-[382px] object-contain"
        />
        <img
          src="/hyrox2.png"
          alt="HYROX"
          className="w-[786px] h-[353px] object-contain"
        />
      </div>
      <p className="text-[#48505F] text-[32px] absolute bottom-0 text-center">
        Premium Training Place
      </p>
    </div>
  );
}

export default HiluxPortraitDefault;
